import { Check } from "lucide-react";
import { PageHeader } from "@/components/site/PageHeader";
import { BannerStrip } from "@/components/site/BannerStrip";
import { Reveal } from "@/components/site/Reveal";
import { Stats } from "@/components/site/Stats";
import { ABOUT_STORY, TARGET_CUSTOMERS } from "@/data";

export default function AboutPage() {
  return (
    <>
      <PageHeader
        overline="Our Story"
        title="Protecting families,"
        accent="preserving legacies."
        subtitle="Heritage Family Protection Agency is a family-focused protection and financial services agency built on education, integrity, and trust."
      />

      <BannerStrip testId="about-banner" />

      <section className="relative py-12 md:py-16">
        <div className="max-w-4xl mx-auto px-6 md:px-12 space-y-6">
          {ABOUT_STORY.map((p, i) => (
            <Reveal key={i} delay={Math.min(i, 4) * 0.04}>
              <p className={`font-body font-light leading-relaxed ${i === 0 ? "text-lg md:text-xl text-white/80" : "text-base md:text-lg text-white/60"}`}>
                {p}
              </p>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="relative py-20 md:py-28 bg-[#0a192f] border-y border-[#bf953f]/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <Reveal>
            <p className="font-body text-xs md:text-sm tracking-[0.3em] uppercase text-[#d4af37]">Who We Serve</p>
            <h2 className="mt-4 font-serif-display text-4xl sm:text-5xl md:text-6xl font-medium tracking-tight text-white max-w-3xl">
              Built for <span className="text-gold-gradient italic">every family</span> and future.
            </h2>
            <p className="mt-5 max-w-3xl font-body font-light text-base md:text-lg leading-relaxed text-white/60">
              We're especially focused on helping families who may be financially unprepared for the loss of a loved
              one — reducing reliance on fundraisers and donations to cover funerals, mortgages, and household bills.
            </p>
          </Reveal>

          <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-4">
            {TARGET_CUSTOMERS.map((c, i) => (
              <Reveal key={i} delay={(i % 2) * 0.04}>
                <div className="flex items-start gap-3 border-t border-white/10 pt-4">
                  <Check size={17} className="mt-0.5 shrink-0 text-[#d4af37]" />
                  <span className="font-body text-white/70 leading-relaxed">{c}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <Stats />
    </>
  );
}
